import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import qs from 'qs'

const DonateState = State({
  initial: {
  }
})

// eslint-disable-next-line
const donateEffect = Effect('donate', (values) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(values)
  return axios.post(`${apiAddress}donate/pay`, urlParams)
})

// eslint-disable-next-line
const donateCountSellMugTshirtEffect = Effect('donateCountSellMugTshirt', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}donate/count-mug-tshirt`).then((res) => {
    Actions.setRemainedElements(res.data)
    return res.data
  })
})

export default DonateState



// WEBPACK FOOTER //
// ./src/states/donate.js